import type { VPNSupportSessionListFilters } from "@src/cloud-connect/api/vpn-manager/vpn-get-support-sessions";
import type { SupportSession } from "@src/types/vpn-support-session";
import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const getVPNSupportSessionsUseCase = async (
  params?: VPNSupportSessionListFilters,
): Promise<{
  success: boolean;
  data: Record<string, SupportSession[]>;
  error?: string;
}> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const data = await apiUseCases.getVPNSupportSessions(namespace, params);

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      data: {},
      error: parseAxiosApiError(error, "Failed to fetch support sessions.")
        .message,
    };
  }
};
